var drawer = function () {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }
    var settings = {
      speedOpen: 200,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',

    };


    var toggleccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };


    var openDrawer = function (trigger) {
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
      target.classList.add(settings.activeClass);
      if((navigator.platform == 'Mac68K') || (navigator.platform == 'MacPPC') || (navigator.platform == 'MacIntel') || (navigator.platform == 'iPhone')){
        document.body.style.overflow = 'hidden';
      } else {
        document.body.classList.add('cart-show');
      }

      if (document.getElementById('minimized-trustbadge-98e3dadd90eb493088abdc5597a70810')){
        document.getElementById('minimized-trustbadge-98e3dadd90eb493088abdc5597a70810').setAttribute('style','display: none !important');
      }
      


      setTimeout(function () {
        target.classList.add(settings.visibleClass);
      }, settings.speedOpen);
    };

    var closeDrawer = function (event) {
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      closestParent.classList.remove(settings.visibleClass);
      if((navigator.platform == 'Mac68K') || (navigator.platform == 'MacPPC') || (navigator.platform == 'MacIntel') || (navigator.platform == 'iPhone')){
        document.body.style.overflow = 'unset';
      } else {
        document.body.classList.remove('cart-show');
      }
      toggleccessibility(childrenTrigger);
      if (document.getElementById('minimized-trustbadge-98e3dadd90eb493088abdc5597a70810')){
        document.getElementById('minimized-trustbadge-98e3dadd90eb493088abdc5597a70810').style.display = 'block';
      }
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
      
    };
    var clickHandler = function (event) {
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);


      if (open) { openDrawer(open); }
      if (close) { closeDrawer(close); }
      //if (open || close) { event.preventDefault(); }
    };


    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
};

drawer();
